import React, { FC } from 'react'

import { IconHeartProps } from './IconHeart.types'
import * as Styled from './styles/IconHeart.style'

import { nonThemeableRules } from '../../ruleSet'

const IconHeart: FC<IconHeartProps> = ({
  size = nonThemeableRules.defaultSize as number as IconHeartProps['size'],
  isResponsive = false,
}: IconHeartProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M23.998 43.001a43.914 43.914 0 0 1-5.395-3.96c-4.607-3.857-9.04-8.475-11.657-13.977C4.49 19.906 3.778 12 8.29 7.73A9.922 9.922 0 0 1 24 10.481M24 43a43.883 43.883 0 0 0 5.392-3.96c4.608-3.858 9.04-8.475 11.66-13.978 2.458-5.155 3.16-13.06-1.34-17.33a9.92 9.92 0 0 0-15.707 2.75'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconHeart
